export default "__VITE_ASSET__CxL3XCcf__"